import React, { useEffect, useLayoutEffect } from "react";
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official';
import HC_exporting from 'highcharts/modules/exporting'
import exportFromJSON from 'export-from-json';
import Theme from "highcharts/themes/grid-light";


require("highcharts/modules/export-data")(Highcharts);
HC_exporting(Highcharts)
Theme(Highcharts)

const LineChart:  any = (props:any) => {


	
    // console.log(props.allData);
    let buttons = Highcharts.getOptions().exporting?.buttons?.contextButton?.menuItems?.slice();
	buttons?.push("label");
    const {allData, exportExcel,exportpdf,exportarImagen, labels, title,subtitle, idChart, activeButton, colores,formatDataStringData,numDecimalProps,pieTextProps,showPieTextInGraph,showSeries} = props;
    const options = {
		chart:{
			type: 'spline',
			colorCount: 15,
			zoomType: 'x',
			backgroundColor: '#ffffff',
			height: 500,
			
        
		},

		title: {
			text: title,

			style: {
				color: '#19355F',
				fontFamily: 'Montserrat'
				
			}
		}
		, subtitle: {
			text: subtitle,
			style: {
				color: '#19355F',
				fontFamily: 'Montserrat-Medium',
				width: '80%',
				wordBreak: 'break-word'
			}
			
		},
	
		yAxis: {
			minorGridLineWidth: 0,
			gridLineWidth: 0,
			title: "enabled"
			, reversed: false,
			labels:{
				format: '{value}'+formatDataStringData,
				style: {
					fontFamily: 'Montserrat, sans-serif',
					color: '#19355F'
				  }
			}
		},

		
	
		xAxis: {
			gridLineWidth: 0,
			categories : labels,
			max: (labels.length - 1)
		},

		tooltip: {
			shared: false,
			useHTML: true,
			headerFormat: '<table><tr><th colspan="2">{point.key}</th></tr>',
			pointFormat: '<tr><td style="color: {series.color}">{series.name}: </td>' +
				'<td style="text-align: right"><b>{point.y}'+formatDataStringData+'</b></td></tr>',
			footerFormat: '</table>',
			valueDecimals: numDecimalProps
		},
	
	
		plotOptions: {
			series: {
				connectNulls: true ,// Conectar los puntos aunque haya valores nulos para todas las series

                    dataLabels: {
                        enabled: false
                    }
                

			},
		
			
		},
		credits: {
			enabled: pieTextProps.length > 0 &&showPieTextInGraph? true : false,
			text: pieTextProps,
			style: {
			  fontSize: '10px',
			  fontFamily: 'Montserrat',
			  color: '#19355F',
			  
			},
			useHTML: true ,// Permite el uso de HTML en el pie de página
			position: {
			  align: 'right',
			  x: -10,
			  verticalAlign: 'bottom',
			  y: -5
			}
		  },
		
	
		series: allData,
		// colors: ['#00A3E0', '#8031A7', '#B5BD00', '#ed8b00', '#09699c', '#ffc000', '#E0004D',
		// 		 '#00C389', '#707372', '#bfbfbf'],
		colors: colores,
		legend: {
			padding:20,
			enabled: true,
			symbolPadding: 5,
			itemDistance:60,
			backgroundColor: '#FFFFFF',
			itemStyle: {
				color: '#19355F',
				fontFamily: 'Montserrat',
				fontSize: '10px',
				fontWeight: 'normal',
				padding: 50
			}
		},
	
		responsive: {  
			rules: [{  

			
			  condition: {  
				maxWidth: 1000
			  },  
			  chartOptions: {
				chart:{
					height: 6000,
					width:8900
				},
				title: {		
					style: {
						fontFamily: 'Sans-Serif',
						fontSize: '12px'
					}
				},
				xAxis:{
					labels:{
						style:{
							fontSize: '8px',
						}
					}

				},
				legend: {

					enabled: true,
					backgroundColor: '#FFFFFF',
					itemStyle: {
						color: '#19355F',
						fontFamily: 'Montserrat',
						fontSize: '11px',
						fontWeight: 'normal',
						padding: '10',
						symbolRadius: 6,
						symbolWidth: 22,
						symbolPadding: 10,
						
					}
				},
				subtitle: {
					style: {
						color: '#19355F',
						fontFamily: 'Montserrat',
						width: '80%',
						wordBreak: 'break-word',
						fontSize: '8px',

					}
					
				},
               
            }
			}]  
		  },
		  
		  lang: {
			downloadCSV: 'Descargar CSV',
			downloadJPEG: "Descargar JPEG",
			downloadPDF: "Descargar PDF",
			downloadPNG: "Descargar PNG",      
			downloadSVG: "Descargar SVG",
			downloadXLS: "Descargar XLS",
			exitFullscreen: "Salir de pantalla completa",
			viewFullscreen: "Ver Pantalla Completa",
			printChart: "Imprimir Gráfico"
		  },

		  exporting: {
			enabled: activeButton, 
			menuItemDefinitions: {
				// Custom definition
				label: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportExcel({titulo: title, id: idChart});
					},
					text: 'Descargar XLSX'
				},
				descargarImagen: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportarImagen();
					},
					text: 'Descargar Imagen'
				},
				descargarPDF: {
					onclick: (event:any) => {
						console.log('clic boton custom');
						exportpdf();
					},
					text: 'Descargar PDF'
				},
				
			},
			
			buttons: {
				contextButton: {
					menuItems: [
						"descargarImagen",
						exportpdf?"descargarPDF":'',
						"separator",
						"label"

					]
				}
			},
			plotOptions: {
                series: {
                    dataLabels: {
                        enabled: false
                    }
                }
            }
		},

	}

    return (
        <>
            <HighchartsReact highcharts={Highcharts} options={options}/>
        </>
    )
}

export default LineChart;